var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pinterest_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.889 0c-6.628 0-12 5.373-12 12 0 5.084 3.163 9.43 7.627 11.178-.105-.95-.2-2.41.041-3.446.218-.936 1.407-5.965 1.407-5.965s-.359-.718-.359-1.781c0-1.669.967-2.915 2.172-2.915 1.023 0 1.518.77 1.518 1.69 0 1.03-.655 2.57-.994 3.996-.283 1.195.6 2.169 1.777 2.169 2.133 0 3.773-2.25 3.773-5.495 0-2.874-2.065-4.882-5.013-4.882-3.414 0-5.419 2.56-5.419 5.207 0 1.032.398 2.137.894 2.739a.36.36 0 0 1 .083.344c-.091.379-.294 1.194-.334 1.36-.052.22-.174.267-.4.161-1.5-.697-2.437-2.888-2.437-4.649 0-3.785 2.75-7.261 7.93-7.261 4.162 0 7.397 2.966 7.397 6.93 0 4.136-2.608 7.464-6.227 7.464-1.216 0-2.36-.631-2.75-1.378 0 0-.602 2.292-.748 2.853-.271 1.042-1.002 2.349-1.491 3.146 1.123.348 2.316.535 3.553.535 6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pinterest_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.889 0h24v24h-24z"
  })))));
};
export default SvgPinterest;